import { render } from "./MenuItem.vue?vue&type=template&id=ff8d806e&scoped=true"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=ff8d806e&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8d806e"]])

export default __exports__